module.exports = __webpack_public_path__ + "static/media/WeTransfer.8427bf27.svg";